import React, { useState, useRef } from "react";
import { DraggableProvidedDragHandleProps } from "react-beautiful-dnd";
import DeleteOutlineIcon from "@material-ui/icons/DeleteOutline";
import MoreHorizOutlinedIcon from "@material-ui/icons/MoreHorizOutlined";
import AddCircleOutlineOutlinedIcon from "@material-ui/icons/AddCircleOutlineOutlined";
import EditOutlinedIcon from "@material-ui/icons/EditOutlined";
import { IconButton, Typography, Paper, MenuItem } from "@material-ui/core";
import Grow from "@material-ui/core/Grow";

import OutsideClickHandler from "components/OutsideClickHandler";
import SvgI24Menu from "assets/icons/I24Menu";
import TrimmedText from "components/TrimmedText";
import {
  Container,
  ControlsContainer,
  DetailsContainer,
  Menu,
  MenuList,
  MenuIconContainer,
  MenuControlWrapper,
  Popper,
  TextContainer,
  TitleWrapper,
} from "./styles";

type Props = {
  title: string;
  details?: any;
  onRemove?: () => void;
  closePopup?: () => void;
  isDragging?: boolean;
  isEditMode?: boolean;
  dragHandleProps?: DraggableProvidedDragHandleProps;
  innerRef?: any;
  onAddOptionClick?: any;
  onEditQuestionClick: any;
};

const QuestionCard = ({
  title,
  details,
  dragHandleProps,
  isDragging,
  isEditMode,
  innerRef,
  onRemove,
  onAddOptionClick,
  onEditQuestionClick,
  ...restProps
}: Props) => {
  return (
    <>
      <Container ref={innerRef} isDragging={isDragging} {...restProps}>
        <DetailsContainer>
          <TextContainer>
            <TitleWrapper>
              <TrimmedText lines={1} text={title}>
                <Typography variant="h4" color="textPrimary">
                  {title}
                </Typography>
              </TrimmedText>
            </TitleWrapper>
          </TextContainer>
        </DetailsContainer>
        {isEditMode && (
          <>
            <ControlsContainer>
              <IconButton color="secondary" onClick={onAddOptionClick}>
                <AddCircleOutlineOutlinedIcon />
              </IconButton>

              <IconButton color="secondary" onClick={onEditQuestionClick}>
                <EditOutlinedIcon />
              </IconButton>

              <IconButton color="secondary" onClick={onRemove}>
                <DeleteOutlineIcon />
              </IconButton>

              <MenuControlWrapper>
                <Menu {...dragHandleProps}>
                  <SvgI24Menu />
                </Menu>
              </MenuControlWrapper>
            </ControlsContainer>
          </>
        )}
      </Container>
    </>
  );
};

export default QuestionCard;
